export default __webpack_public_path__ + "images/a934c88da769603554884af24d0531fd-rudy-parachute.gif";